import { gql, useQuery } from "@apollo/client";
import useRetryOn429 from "hooks/useRetryOn429";
import { Select } from "../base/Form";

const FETCH_ODOO_USERS = gql`
  query FETCH_ODOO_USERS($instance: String!, $company: String!) {
    odooUsers(instance: $instance, company: $company)
  }
`;

const OdooUserSelector = ({ instance, company, value, onSelect, ...rest }) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_USERS, {
    variables: { instance, company },
    skip: !instance || !company,
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  const odooUsers = data
    ? JSON.parse(data.odooUsers).sort((a, b) =>
        a.display_name.localeCompare(b.display_name),
      )
    : [];

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(parseInt(e.target.value, 10))}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0" disabled>
            --- Select ---
          </option>
          {odooUsers.map((i) => (
            <option key={i.id} value={i.id}>
              {i.display_name}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooUserSelector;
